import { useCallback } from 'react'
import ApiService from 'services/ApiService'

const InteractorMasterInventoryCategorySearch = () => {
  const masterInventoryCategorySearch = useCallback((body, callback, loading) => {
    const payload = {
      ...body,
    }
    ApiService.jsonRequest('/warehouse/master-inventory/category-search', payload, (response) => {
      loading(false)
      if (response.code === 7200) {
        callback(response.data)
      } else {
        callback(null)
      }
    })
  }, [])
  return { masterInventoryCategorySearch }
}

export default InteractorMasterInventoryCategorySearch
